export const authors = ({dispatch}) => next => (action) => {
    next(action);
}
